import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { STEP_ORDER, TWO_FA_REDIRECTION } from './constants';
import type { SetupTwoFAState } from './types';

export const useSetupTwoFAStore = create<SetupTwoFAState>()(
  persist(
    (set, get) => ({
      isOpen: false,
      step: null,
      resolver: null,
      redirectionUrl: null,
      secretCode: null,
      qrCode: null,

      beginSetupTwoFA: () => {
        set({ isOpen: true, step: 'intro' });
        return new Promise<void>((resolve) => {
          set({
            resolver: () => {
              set({ isOpen: false, resolver: null });
              resolve();
            },
          });
        });
      },

      successSetupTwoFA: () => {
        const resolver = get().resolver;
        if (resolver) resolver();
        set({ isOpen: false, resolver: null });
      },

      goToStep: (step) => {
        set({ step });
      },

      nextStep: () => {
        const currentStep = get().step;
        if (!currentStep) return;
        const index = STEP_ORDER.indexOf(currentStep);
        if (index < STEP_ORDER.length - 1) {
          set({ step: STEP_ORDER[index + 1] });
        }
      },

      prevStep: () => {
        const currentStep = get().step;
        if (!currentStep) return;
        const index = STEP_ORDER.indexOf(currentStep);
        if (index > 0) {
          set({ step: STEP_ORDER[index - 1] });
        }
      },

      setRedirectionUrl: (url) => {
        set({ redirectionUrl: url });
      },

      clearRedirectionUrl: () => {
        set({ redirectionUrl: null });
        localStorage.removeItem(TWO_FA_REDIRECTION);
      },

      setupTwoFA: (params) => {
        const { qrCode, secretCode } = params;
        set({ qrCode });
        set({ secretCode });
      },
    }),
    {
      name: TWO_FA_REDIRECTION,
      partialize: (state) => ({ redirectionUrl: state.redirectionUrl }),
    }
  )
);
